{
    "May the force be with you": "May the force be with you",
    "Digit1": "1",
    "Digit2": "2",
    "Digit3": "3",
    "Digit4": "4",
    "Digit5": "5",
    "Digit6": "6",
    "Digit7": "7",
    "Digit8": "8",
    "Digit9": "9",
    "Digit0": "0",
    "KeyA": "A",
    "KeyB": "B",
    "KeyC": "C",
    "KeyD": "D",
    "KeyE": "E",
    "KeyF": "F",
    "KeyG": "G",
    "KeyH": "H",
    "KeyI": "I",
    "KeyJ": "J",
    "KeyK": "K",
    "KeyL": "L",
    "KeyM": "M",
    "KeyN": "N",
    "KeyO": "O",
    "KeyP": "P",
    "KeyQ": "Q",
    "KeyR": "R",
    "KeyS": "S",
    "KeyT": "T",
    "KeyU": "U",
    "KeyV": "V",
    "KeyW": "W",
    "KeyX": "X",
    "KeyY": "Y",
    "KeyZ": "Z",
    "Comma": ",",
    "Period": ".",
    "Semicolon": ";",
    "Quote": "'",
    "BracketLeft": "[",
    "BracketRight": "]",
    "Backquote": "`",
    "Backslash": "\\",
    "Minus": "-",
    "Equal": "=",
    "AltLeft": "Alt",
    "AltRight": "Alt",
    "CapsLock": "CapsLock",
    "ControlLeft": "ControlLeft",
    "ControlRight": "ControlRight",
    "OSLeft": "OSLeft",
    "OSRight": "OSRight",
    "ShiftLeft": "ShiftLeft",
    "ShiftRight": "ShiftRight",
    "ContextMenu": "ContextMenu",
    "Enter": "Enter",
    "Space": "Space",
    "Tab": "Tab",
    "Delete": "Delete",
    "End": "End",
    "Help": "Help",
    "Home": "Home",
    "Insert": "Insert",
    "PageDown": "PageDown",
    "PageUp": "PageUp",
    "ArrowDown": "ArrowDown",
    "ArrowLeft": "ArrowLeft",
    "ArrowRight": "ArrowRight",
    "ArrowUp": "ArrowUp",
    "Escape": "Escape",
    "PrintScreen": "PrintScreen",
    "ScrollLock": "ScrollLock",
    "Pause": "Pausa",
    "Put the videos side by side": "Put the videos side by side",
    "Minimize video": "Minimize video",
    "Close video": "Close video",
    "Place the video on the other side of the screen": "Place the video on the other side of the screen",
    "Maximize video": "Maximize video",
    "Swap position of the videos": "Swap position of the videos",
    "loadManifest(): Invalid current player state: $1": "loadManifest(): Invalid current player state: $1",
    "loadPlayer(): Invalid current player state: $1": "loadPlayer(): Invalid current player state: $1",
    "Could not load player: state transition in progress: $1": "Could not load player: state transition in progress: $1",
    "Could not unload player: state transition in progress: $1": "Could not unload player: state transition in progress: $1",
    "unloadManifest(): Invalid current player state: $1": "unloadManifest(): Invalid current player state: $1",
    "Error loading video manifest: $1 $2": "Error loading video manifest: $1 $2",
    "Play/pause": "Play/pause",
    "Select the active audio track": "Select the active audio track",
    "Toggle audio mute": "Toggle audio mute",
    "Toggle play/pause": "Toggle play/pause",
    "Toggle captions": "Toggle captions",
    "Backward $1 seconds": "Backward $1 seconds",
    "Forward $1 seconds": "Forward $1 seconds",
    "Volume up 10%": "Volume up 10%",
    "Volume down 10%": "Volume down 10%",
    "Close pop-up": "Close pop-up",
    "Decrease playback speed": "Decrease playback speed",
    "Increase playback speed": "Increase playback speed",
    "Swap between side by side and minimized video": "Swap between side by side and minimized video",
    "Swap the position of the videos": "Swap the position of the videos",
    "playPauseButtonHelp.title": "Play/Pause Button Help",
    "playPauseButtonHelp.description": "This button allows you to play or pause the video.",
    "Dual stream 50%": "Dual stream 50%",
    "Two videos 50%": "Two videos 50%",
    "Play/Pause button": "Play/Pause button",
    "Starts and stops video playback. When the video reaches the end, this button also allows you to restart playback from the beginning.": "Starts and stops video playback. When the video reaches the end, this button also allows you to restart playback from the beginning.",
    "Toolbar": "Toolbar",
    "Left-side buttons": "Left-side buttons",
    "Right-side buttons": "Right-side buttons",
    "Back": "Back",
    "Play": "Play",
    "Options": "Options",
    "Configuration options": "Configuration options",
    "Settings": "Settings",
    "Settings options": "Settings options"
}